export default {
  PUBLISHER: "PUBLISHER",
  POSITION: "POSITION",
  TIME: "TIME",
};
